import { AnalyticsEvents, useUserInfo } from "@next-platform/client-common-core";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import useAuth from "@/services/useAuth";
import { getIsPartner } from "@/utils/getIsPartner";
import { hasValidAuthCode } from "@/utils/hasValidAuthCode";

import useQueueLogEvent from "./useQueueLogEvent";

export function useLoginEvent() {
  const { logEvent } = useQueueLogEvent();
  const { isAuthenticated } = useAuth();
  const { userProfile: profile, isProfileLoaded } = useUserInfo();

  const isPartner = getIsPartner();

  const location = useLocation();

  const [triggerLogin, setTriggerLogin] = useState(false);

  useEffect(() => {
    if (hasValidAuthCode(location.search)) {
      setTriggerLogin(true);
    }
  }, [location.search]);

  useEffect(() => {
    if (triggerLogin && isAuthenticated && isProfileLoaded && !isPartner && profile) {
      const { username } = profile;
      logEvent(username ? AnalyticsEvents.LOGIN : AnalyticsEvents.SIGN_UP, { username });
      setTriggerLogin(false);
    }
  }, [triggerLogin, isAuthenticated, location, isProfileLoaded, profile]);
}
